export default __webpack_public_path__ + "static/media/arrow-right.inline.8bac07eb.svg";